import { gql } from "@apollo/client"

import imageFields from "./partials/imageFields"
import seoFields from "./partials/seoFields"
import sys from "./partials/sys"

export const leadGenLgId = "19CgDo5QJIlIpcgcHxi9P0"
export const leadGenTyId = "5OdLjQbRw8NTkkmMxpSvMz"
export const leadgenLgCollection = `contentType${leadGenLgId}Collection`
export const leadgenTyCollection = `contentType${leadGenTyId}Collection`

export const leadgenLgFields = `
  title
  ${sys}
  slug
  topDescriptionFirst
  topDescriptionSecond
  additionalTextTitle
  additionalTextFirst
  additionalTextSecond
  eyebrowTitle
  topHeroCta
  formUrl
  body
  date
  formHeadline
  hubspotFormUrl
  seo {
    ${seoFields}
  }
  carouselCollection{
    total
    items{
      ${imageFields}
    }
  }
`

const leadgenTyFields = `
  title
  ${sys}
  slug
  thankYouTitle
  thankYouSubtitle
  buttonCta
  buttonLink
  seo {
    ${seoFields}
  }
`

export const GET_ALL_LEADGEN_LG_QUERY = gql`
query Leadgen_LG{
  ${leadgenLgCollection} {
    items {
      title
      ${sys}
      slug
    }
  }
}
`

export const GET_ALL_LEADGEN_TY_QUERY = gql`
query Leadgen_TY{
  ${leadgenTyCollection} {
    items {
      title
      ${sys}
      slug
    }
  }
}
`

export const GET_LEADGEN_LG_AND_TY_QUERY = gql`
query getLeadgenLG($slug: String!){
  ${leadgenLgCollection}(
    where: { slug: $slug }
    limit: 1
  ) {
    items {
      ${leadgenLgFields}
    }
  }
  ${leadgenTyCollection}(
    where: { slug: $slug }
    limit: 1
  ) {
    items {
      ${leadgenTyFields}
    }
  }
}
`

export const GET_LEADGEN_LG_QUERY = gql`
query getLeadgenLG($slug: String!, $preview: Boolean!){
  ${leadgenLgCollection}(
    where: { slug: $slug }
    preview: $preview
    limit: 1
  ) {
    items {
      ${leadgenLgFields}
    }
  }
}
`

export const GET_LEADGEN_TY_QUERY = gql`
query getLeadgenTY($slug: String!, $preview: Boolean!){
  ${leadgenTyCollection}(
    where: { slug: $slug }
    preview: $preview
    limit: 1
  ) {
    items {
      ${leadgenTyFields}
    }
  }
}
`

export interface AssetSys {
  __typename: "Sys"
  id: string
}

export interface Asset {
  __typename: "Asset"
  sys: AssetSys | null
  url: string | null
  title: string | null
  width: number | null
  height: number | null
  description: string | null
  contentType: string | null
}

export interface Sys {
  id: string
  __typename: "Sys"
}

export interface ComponentSeo {
  __typename: "ComponentSeo"
  seoTitle: string | null
  seoDescription: string | null
  ogTitle: string | null
  ogDescription: string | null
  ogImage: Asset | null
  featuredImage: Asset | null
  hidePageFromSearchEnginesNoIndex: boolean | null
  excludeLinksFromSearchRankingsNofollow: boolean | null
  canonicalUrl: string | null
}

export interface AssetCollection {
  __typename: "AssetCollection"
  total: number | null
  items: (Asset | null)[]
}

export interface ContentType19CgDo5QJIlIpcgcHxi9P0 {
  __typename: "ContentType19CgDo5QJIlIpcgcHxi9P0"
  sys: Sys
  title: string | null
  slug: string | null
  topDescriptionFirst: string | null
  topDescriptionSecond: string | null
  additionalTextTitle: string | null
  additionalTextFirst: string | null
  additionalTextSecond: string | null
  eyebrowTitle: string | null
  topHeroCta: string | null
  formUrl: string | null
  body: string | null
  date: string | null
  formHeadline: string | null
  hubspotFormUrl: string | null
  seo: ComponentSeo | null
  carouselCollection: AssetCollection | null
}

/**
 * Thank you page content
 */
export interface ContentType5OdLjQbRw8NTkkmMxpSvMz {
  __typename: "ContentType5OdLjQbRw8NTkkmMxpSvMz"
  sys: Sys
  title: string | null
  slug: string | null
  thankYouTitle: string | null
  thankYouSubtitle: string | null
  buttonCta: string | null
  buttonLink: string | null
  seo: ComponentSeo | null
}

/**
 * Thank you Lead-gen content model
 */
export interface ContentType5OdLjQbRw8NTkkmMxpSvMzCollection {
  __typename: "ContentType5OdLjQbRw8NTkkmMxpSvMzCollection"
  items: (ContentType5OdLjQbRw8NTkkmMxpSvMz | null)[]
}

/**
 * Lead-gen Contentful content model
 */
export interface ContentType19CgDo5QJIlIpcgcHxi9P0Collection {
  __typename: "ContentType19CgDo5QJIlIpcgcHxi9P0Collection"
  items: (ContentType19CgDo5QJIlIpcgcHxi9P0 | null)[]
}

export interface GetLeadGenLGQuery {
  contentType19CgDo5QJIlIpcgcHxi9P0Collection: ContentType19CgDo5QJIlIpcgcHxi9P0Collection
  contentType5OdLjQbRw8NTkkmMxpSvMzCollection: ContentType5OdLjQbRw8NTkkmMxpSvMzCollection
}
